import { useNavigate } from "react-router-dom";
import { ClipboardList, ShieldCheck, Wifi, Utensils, MapPin, Phone, Globe, ShoppingBag } from "lucide-react";

function Dashboard() {
  const navigate = useNavigate();

  const cardItems = [
    {
      title: "Registration",
      icon: <ClipboardList className="w-8 h-8 text-indigo-700" />, // Changed to indigo for a slightly richer blue
      color: "hover:border-indigo-500",
      onClick: () => navigate("/registration"),
    },
    {
      title: "Room Policy",
      icon: <ShieldCheck className="w-8 h-8 text-emerald-700" />, // Changed to emerald for a distinct green
      color: "hover:border-emerald-500",
      onClick: () => navigate("/roompolicy"),
    },
    {
      title: "WiFi",
      icon: <Wifi className="w-8 h-8 text-purple-700" />, // Changed to a deeper purple
      color: "hover:border-purple-500",
      onClick: () => navigate("/wifi"),
    },
    {
      title: "Menu (Online Order)",
      icon: <Utensils className="w-8 h-8 text-orange-600" />, // Using a more direct orange
      color: "hover:border-orange-400",
      onClick: () => navigate("/menu"),
    },
    {
      title: "Recent Orders",
      icon: <ShoppingBag className="w-8 h-8 text-yellow-800" />, // Consistent with Menu
      color: "hover:border-yellow-600",
      onClick: () => navigate("/recentorders"),
    },
    {
      title: "Things to Do",
      icon: <MapPin className="w-8 h-8 text-rose-700" />, // Changed to rose for a warmer pink
      color: "hover:border-rose-500",
      onClick: () => navigate("/thingstodo"),
    },
    // {
    //   title: "Vehicle Rent",
    //   icon: <Car className="w-8 h-8 text-fuchsia-700" />, // Changed to fuchsia to differentiate slightly from 'Things to Do' while still being in the pink/purple family
    //   color: "hover:border-fuchsia-500",
    //   onClick: () => navigate("/vehiclerent"), // Note: This navigates to "/kitchen" currently. Is this intentional for "Vehicle Rent"?
    // },
    {
      title: "Contact",
      icon: <Phone className="w-8 h-8 text-red-700" />, // Slightly darker red for impact
      color: "hover:border-red-500",
      onClick: () => navigate("/contact"),
    },
    {
      title: "Website",
      icon: <Globe className="w-8 h-8 text-blue-700" />, // Using a standard blue for web
      color: "hover:border-blue-500",
      onClick: () => window.open("https://woodchaletsella.com.lk", "_blank"),
    },
  ];

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-gray-50 to-gray-100 text-gray-900">
      {/* Header */}
      <header className="p-6 bg-white shadow-lg">
  <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-4">
    <div className="text-center sm:text-left flex-grow">
      <h3 className="text-xl font-semibold text-gray-600 text-center">
        Welcome to Wood Chalets Ella
      </h3>
    </div>
  </div>
</header>

      {/* Main */}
      <main className="flex-grow p-4 max-w-7xl mx-auto w-full">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardItems.map((card, index) => (
            <button
              key={index}
              onClick={card.onClick}
              className={`relative w-full bg-white rounded-2xl shadow-md p-6 flex items-center
                space-x-4 transform transition-all duration-300 hover:shadow-xl
                focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 border-2 border-transparent ${card.color}`}
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter') card.onClick(); }}
            >
              {card.icon}
              <span className="text-lg font-semibold text-gray-800 group-hover:text-blue-600 transition-colors">
                {card.title}
              </span>
            </button>
          ))}
        </div>
      </main>

      {/* Footer */}
      <footer className="p-6 bg-white shadow-inner text-center text-sm text-gray-500">
        <div className="max-w-7xl mx-auto">
          © {new Date().getFullYear()} Wood Chalets Ella. All rights reserved.
        </div>
        <div className="max-w-7xl mx-auto">
        Design & Development <a href="https://akasa.lk">@Akasa.lk</a>
        </div>
      </footer>
    </div>
  );
}

export default Dashboard;